// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var IOUtils = require("./IOUtils.bs.js");
var ReactIO = require("./ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactDom = require("react-dom");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var ReasonReactRouter = require("reason-react/src/ReasonReactRouter.bs.js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");
var SmoothScrollIntoViewIfNeeded = require("smooth-scroll-into-view-if-needed").default;

var make = (function fuckYouWebpack() {
        if (typeof window == 'undefined') {
          return;
        }

        return window;
      });

function redirectTo(url) {
  var partial_arg = function (param) {
    return Relude_Globals.flip((function (prim, prim$1) {
                  prim.location.href = prim$1;
                  
                }), url, param);
  };
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(undefined, partial_arg, param);
  };
  return Relude_IO.suspend(function (param) {
              return Relude_Globals.$great$great(make, partial_arg$1, param);
            });
}

function openWindow(url) {
  var partial_arg = function (param) {
    return Relude_Globals.flip((function (prim, prim$1) {
                  prim.open(prim$1);
                  
                }), url, param);
  };
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(undefined, partial_arg, param);
  };
  return Relude_IO.suspend(function (param) {
              return Relude_Globals.$great$great(make, partial_arg$1, param);
            });
}

var scrollToTop = Curry._2(Relude_IO.mapError, (function (prim) {
        
      }), Relude_IO.suspend(function (param) {
          return Relude_Globals.$great$great(make, (function (param) {
                        return Relude_Option.fold(undefined, (function (__x) {
                                      __x.scrollTo(0, 0);
                                      
                                    }), param);
                      }), param);
        }));

function openTab(url) {
  var partial_arg = function (param) {
    return Relude_Globals.flip((function (prim, prim$1) {
                  prim.open(prim$1, "_blank");
                  
                }), url, param);
  };
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(undefined, partial_arg, param);
  };
  return Relude_IO.suspend(function (param) {
              return Relude_Globals.$great$great(make, partial_arg$1, param);
            });
}

var hasFocus = Relude_IO.map((function (param) {
        return Relude_Option.fold(false, (function (prim) {
                      return prim.document.hasFocus();
                    }), param);
      }), Relude_IO.suspend(make));

var $$Window = {
  make: make,
  redirectTo: redirectTo,
  openWindow: openWindow,
  scrollToTop: scrollToTop,
  openTab: openTab,
  hasFocus: hasFocus
};

function getModifierKeysFromEvent(e) {
  return {
          alt: e.altKey,
          ctrl: e.ctrlKey,
          meta: e.metaKey,
          shift: e.shiftKey
        };
}

function getModifierKeysFromDomEvent(e) {
  return {
          alt: e.altKey,
          ctrl: e.ctrlKey,
          meta: e.metaKey,
          shift: e.shiftKey
        };
}

var ModifierKeys = {
  getModifierKeysFromEvent: getModifierKeysFromEvent,
  getModifierKeysFromDomEvent: getModifierKeysFromDomEvent
};

function escapeKey(param_0) {
  return {
          TAG: /* EscapeKey */0,
          _0: param_0
        };
}

function enterKey(param_0) {
  return {
          TAG: /* EnterKey */1,
          _0: param_0
        };
}

function arrowUp(param_0) {
  return {
          TAG: /* ArrowUp */2,
          _0: param_0
        };
}

function arrowDown(param_0) {
  return {
          TAG: /* ArrowDown */3,
          _0: param_0
        };
}

function fromString(modifierKeys, param) {
  switch (param) {
    case "ArrowDown" :
        return Relude_Option.pure({
                    TAG: /* ArrowDown */3,
                    _0: modifierKeys
                  });
    case "ArrowUp" :
        return Relude_Option.pure({
                    TAG: /* ArrowUp */2,
                    _0: modifierKeys
                  });
    case "Enter" :
        return Relude_Option.pure({
                    TAG: /* EnterKey */1,
                    _0: modifierKeys
                  });
    case "Escape" :
        return Relude_Option.pure({
                    TAG: /* EscapeKey */0,
                    _0: modifierKeys
                  });
    default:
      return ;
  }
}

function getKeyFromEvent(e) {
  return Relude_Option.map((function (key) {
                return [
                        key,
                        e
                      ];
              }), fromString(getModifierKeysFromEvent(e), e.key));
}

function getKeyFromDomEvent(e) {
  return Relude_Option.map((function (key) {
                return [
                        key,
                        e
                      ];
              }), fromString(getModifierKeysFromDomEvent(e), e.key));
}

var KeyMappings = {
  ModifierKeys: ModifierKeys,
  escapeKey: escapeKey,
  enterKey: enterKey,
  arrowUp: arrowUp,
  arrowDown: arrowDown,
  fromString: fromString,
  getKeyFromEvent: getKeyFromEvent,
  getKeyFromDomEvent: getKeyFromDomEvent
};

function getElementsByTagName(tagName) {
  return Relude_IO.suspend(function (param) {
              return document.getElementsByTagName(tagName);
            });
}

function getElementByTagName(tagName) {
  return Relude_IO.flatMap((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great((function (prim) {
                                            return Array.prototype.slice.call(prim);
                                          }), Relude_Array.head, param);
                            }), (function (param) {
                              return Relude_IO.fromOption(Relude_Globals.id, param);
                            }), param);
              }), Relude_IO.suspend(function (param) {
                  return document.getElementsByTagName(tagName);
                }));
}

function appendChild(child, parent) {
  return Relude_IO.map((function (param) {
                return child;
              }), Relude_IO.suspend(function (param) {
                  parent.appendChild(child);
                  
                }));
}

function appendChildToHead(child) {
  return Relude_IO.flatMap((function (param) {
                return appendChild(child, param);
              }), getElementByTagName("head"));
}

function appendChildToBody(child) {
  return Relude_IO.flatMap((function (param) {
                return appendChild(child, param);
              }), getElementByTagName("body"));
}

function removeChild(child, parent) {
  return Relude_IO.suspend(function (param) {
              return parent.removeChild(child);
            });
}

function removeChildFromHead(child) {
  return Relude_IO.flatMap((function (param) {
                return Relude_IO.suspend(function (param$1) {
                            return param.removeChild(child);
                          });
              }), getElementByTagName("head"));
}

function removeChildFromBody(child) {
  return Relude_IO.flatMap((function (param) {
                return Relude_IO.suspend(function (param$1) {
                            return param.removeChild(child);
                          });
              }), getElementByTagName("body"));
}

function setAttributeOnElement(key, value, element) {
  return Relude_IO.map((function (param) {
                return element;
              }), Relude_IO.suspend(function (param) {
                  element.setAttribute(key, value);
                  
                }));
}

function setInnerHTMLOnElement(html, element) {
  return Relude_IO.map((function (param) {
                return element;
              }), Relude_IO.suspend(function (param) {
                  element.innerHTML = html;
                  
                }));
}

function addKeyDownEventListener(listener) {
  var partial_arg = Relude_IO.pure(undefined);
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(partial_arg, listener, param);
  };
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great(getKeyFromDomEvent, partial_arg$1, param);
  };
  var listener$1 = function (param) {
    return Relude_Globals.$great$great(partial_arg$2, IOUtils.unsafeRunHandledAsync, param);
  };
  return Relude_IO.suspend(function (param) {
              document.addEventListener("keydown", listener$1);
              return /* Wrapper */{
                      _0: listener$1
                    };
            });
}

function removeKeyDownEventListener(listener) {
  var listener$1 = listener._0;
  return Relude_IO.suspend(function (param) {
              document.removeEventListener("keydown", listener$1);
              
            });
}

function addWindowScrollListener(listener) {
  var listener$1 = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$$const(listener, param);
                }), IOUtils.unsafeRunHandledAsync, param);
  };
  return Relude_IO.map((function (param) {
                return /* Wrapper */{
                        _0: listener$1
                      };
              }), Relude_IO.suspend(function (param) {
                  return Relude_Globals.$great$great(make, (function (param) {
                                return Relude_Option.fold(undefined, (function (param) {
                                              param.addEventListener("scroll", listener$1, true);
                                              
                                            }), param);
                              }), param);
                }));
}

function removeWindowScrollListener(listener) {
  var listener$1 = listener._0;
  return Relude_IO.suspend(function (param) {
              return Relude_Globals.$great$great(make, (function (param) {
                            return Relude_Option.fold(undefined, (function (param) {
                                          param.removeEventListener("scroll", listener$1);
                                          
                                        }), param);
                          }), param);
            });
}

function addWindowResizeListener(listener) {
  var listener$1 = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$$const(listener, param);
                }), IOUtils.unsafeRunHandledAsync, param);
  };
  return Relude_IO.map((function (param) {
                return /* Wrapper */{
                        _0: listener$1
                      };
              }), Relude_IO.suspend(function (param) {
                  return Relude_Globals.$great$great(make, (function (param) {
                                return Relude_Option.fold(undefined, (function (param) {
                                              param.addEventListener("resize", listener$1);
                                              
                                            }), param);
                              }), param);
                }));
}

function removeWindowResizeListener(listener) {
  var listener$1 = listener._0;
  return Relude_IO.suspend(function (param) {
              return Relude_Globals.$great$great(make, (function (param) {
                            return Relude_Option.fold(undefined, (function (param) {
                                          param.removeEventListener("resize", listener$1);
                                          
                                        }), param);
                          }), param);
            });
}

function addMouseDownListener(listener) {
  var listener$1 = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great((function (prim) {
                                return prim.target;
                              }), listener, param);
                }), IOUtils.unsafeRunHandledAsync, param);
  };
  return Relude_IO.map((function (param) {
                return /* Wrapper */{
                        _0: listener$1
                      };
              }), Relude_IO.suspend(function (param) {
                  document.addEventListener("mousedown", listener$1, true);
                  
                }));
}

function removeMouseDownListener(listener) {
  var listener$1 = listener._0;
  return Relude_IO.suspend(function (param) {
              document.removeEventListener("mousedown", listener$1, true);
              
            });
}

var WebapiIO = {
  getElementsByTagName: getElementsByTagName,
  getElementByTagName: getElementByTagName,
  appendChild: appendChild,
  appendChildToHead: appendChildToHead,
  appendChildToBody: appendChildToBody,
  removeChild: removeChild,
  removeChildFromHead: removeChildFromHead,
  removeChildFromBody: removeChildFromBody,
  setAttributeOnElement: setAttributeOnElement,
  setInnerHTMLOnElement: setInnerHTMLOnElement,
  addKeyDownEventListener: addKeyDownEventListener,
  removeKeyDownEventListener: removeKeyDownEventListener,
  addWindowScrollListener: addWindowScrollListener,
  removeWindowScrollListener: removeWindowScrollListener,
  addWindowResizeListener: addWindowResizeListener,
  removeWindowResizeListener: removeWindowResizeListener,
  addMouseDownListener: addMouseDownListener,
  removeMouseDownListener: removeMouseDownListener
};

var _map = {"auto":"auto","smooth":"smooth","instant":"instant"};

function behaviorToJs(param) {
  return param;
}

function behaviorFromJs(param) {
  return _map[param];
}

var _map$1 = {"start":"start","center":"center","end_":"end","nearest":"nearest"};

var _revMap = {"start":"start","center":"center","end":"end_","nearest":"nearest"};

function blockToJs(param) {
  return _map$1[param];
}

function blockFromJs(param) {
  return _revMap[param];
}

var _map$2 = {"start":"start","center":"center","end_":"end","nearest":"nearest"};

var _revMap$1 = {"start":"start","center":"center","end":"end_","nearest":"nearest"};

function inlineToJs(param) {
  return _map$2[param];
}

function inlineFromJs(param) {
  return _revMap$1[param];
}

var _map$3 = {"always":"always","ifNeeded":"if-needed"};

var _revMap$2 = {"always":"always","if-needed":"ifNeeded"};

function scrollModeToJs(param) {
  return _map$3[param];
}

function scrollModeFromJs(param) {
  return _revMap$2[param];
}

function t(behavior, block, inline, scrollMode) {
  var partial_arg = Relude_Option.map(scrollModeToJs, scrollMode);
  var partial_arg$1 = Relude_Option.map(inlineToJs, inline);
  var partial_arg$2 = Relude_Option.map(blockToJs, block);
  var partial_arg$3 = Relude_Option.map(behaviorToJs, behavior);
  return function (param) {
    var tmp = {};
    if (partial_arg$3 !== undefined) {
      tmp.behavior = Caml_option.valFromOption(partial_arg$3);
    }
    if (partial_arg$2 !== undefined) {
      tmp.block = Caml_option.valFromOption(partial_arg$2);
    }
    if (partial_arg$1 !== undefined) {
      tmp.inline = Caml_option.valFromOption(partial_arg$1);
    }
    if (partial_arg !== undefined) {
      tmp.scrollMode = Caml_option.valFromOption(partial_arg);
    }
    return tmp;
  };
}

var partial_arg = Curry._1(Relude_Option.flatMap, behaviorFromJs);

function behaviorGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return Caml_option.undefined_to_opt(prim.behavior);
              }), partial_arg, param);
}

var partial_arg$1 = Curry._1(Relude_Option.flatMap, blockFromJs);

function blockGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return Caml_option.undefined_to_opt(prim.block);
              }), partial_arg$1, param);
}

var partial_arg$2 = Curry._1(Relude_Option.flatMap, inlineFromJs);

function inlineGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return Caml_option.undefined_to_opt(prim.inline);
              }), partial_arg$2, param);
}

var partial_arg$3 = Curry._1(Relude_Option.flatMap, scrollModeFromJs);

function scrollModeGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return Caml_option.undefined_to_opt(prim.scrollMode);
              }), partial_arg$3, param);
}

var ScrollOptions = {
  behaviorToJs: behaviorToJs,
  behaviorFromJs: behaviorFromJs,
  blockToJs: blockToJs,
  blockFromJs: blockFromJs,
  inlineToJs: inlineToJs,
  inlineFromJs: inlineFromJs,
  scrollModeToJs: scrollModeToJs,
  scrollModeFromJs: scrollModeFromJs,
  t: t,
  make: t,
  behaviorGet: behaviorGet,
  blockGet: blockGet,
  inlineGet: inlineGet,
  scrollModeGet: scrollModeGet
};

var partial_arg$4 = t(undefined, undefined, undefined, undefined)(undefined);

function partial_arg$5(param) {
  return Relude_Option.getOrElse(partial_arg$4, param);
}

function scrollRefIntoView(param) {
  return Relude_Globals.$great$great(partial_arg$5, (function (param, param$1) {
                return Relude_Globals.flip((function (prim, prim$1) {
                              SmoothScrollIntoViewIfNeeded(prim, prim$1);
                              
                            }), param, param$1);
              }), param);
}

function scrollRefIntoView$1(scrollOptions) {
  var partial_arg = Curry._1(scrollRefIntoView, scrollOptions);
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(undefined, partial_arg, param);
  };
  return function (param) {
    return Relude_IO.map(partial_arg$1, param);
  };
}

function focusRef(domRef) {
  return domRef.focus();
}

function focusRef$1(domRef) {
  return Relude_IO.map((function (param) {
                return Relude_Option.fold(undefined, focusRef, param);
              }), domRef);
}

function clickRef(domRef) {
  return domRef.click();
}

function clickRef$1(domRef) {
  return Relude_IO.map((function (param) {
                return Relude_Option.fold(undefined, clickRef, param);
              }), domRef);
}

function getRefScrollTop(domRef) {
  return domRef.scrollTop;
}

function getRefScrollTop$1(domRef) {
  return Relude_IO.map((function (param) {
                return Relude_Option.fold(0, getRefScrollTop, param);
              }), domRef);
}

function scrollRefIntoViewOnCondition(scrollOptions, condition, domRef) {
  if (condition) {
    return scrollRefIntoView$1(scrollOptions)(domRef);
  } else {
    return Relude_IO.pure(undefined);
  }
}

var ieRegex = /MSIE ([0-9]{1,}[\.0-9]{0,})/;

var safariRegex = /^((?!chrome|android).)*safari/i;

var iosRegex = /(iPod|iPhone|iPad)/;

function isIE(param) {
  try {
    return ieRegex.test(window.navigator.userAgent);
  }
  catch (exn){
    return false;
  }
}

function isSafari(param) {
  try {
    return safariRegex.test(window.navigator.userAgent);
  }
  catch (exn){
    return false;
  }
}

function isSafariDesktop(param) {
  if (!isSafari(undefined)) {
    return false;
  }
  try {
    if (isSafari(undefined)) {
      return !iosRegex.test(window.navigator.userAgent);
    } else {
      return false;
    }
  }
  catch (exn){
    return false;
  }
}

function getValueFromEvent($$event) {
  return $$event.target.value;
}

function getCheckedFromEvent($$event) {
  return $$event.target.checked;
}

function getAt(param, param$1) {
  return Relude_Globals.flip((function (prim, prim$1) {
                return prim.item(prim$1);
              }), param, param$1);
}

function head(param) {
  return getAt(0, param);
}

var $$FileList = {
  getAt: getAt,
  head: head
};

var $$File = {};

function getFilesFromEvent($$event) {
  return $$event.target.files;
}

var FileInput = {
  getFilesFromEvent: getFilesFromEvent
};

function getFocusActionsFromEvent($$event) {
  var target = $$event.target;
  return {
          select: Relude_IO.suspend(function (param) {
                return target.select();
              })
        };
}

function screenWidth(param) {
  return Relude_Option.map((function (prim) {
                return prim.innerWidth;
              }), Curry._1(make, undefined));
}

function subscribeToResizeEvents(cb) {
  return Relude_Option.map((function (__x) {
                __x.addEventListener("resize", cb);
                
              }), Curry._1(make, undefined));
}

var WindowSizing = {
  screenWidth: screenWidth,
  subscribeToResizeEvents: subscribeToResizeEvents
};

function make$1(mediaQuery) {
  return Relude_Option.map((function (__x) {
                return __x.matchMedia(mediaQuery);
              }), Curry._1(make, undefined));
}

function subscribe(listener, mediaMatch) {
  mediaMatch.addListener(listener);
  return function (param) {
    mediaMatch.removeListener(listener);
    
  };
}

var MediaMatch = {
  make: make$1,
  subscribe: subscribe
};

function writeText(text) {
  return Relude_IO.flatMap((function (param) {
                return Relude_Globals.$great$great((function (prim) {
                              return prim.navigator;
                            }), (function (param) {
                              return Relude_IO.bimap((function (prim) {
                                            
                                          }), (function (prim) {
                                            
                                          }), Relude_Js_Promise.toIOLazy(function (param$1) {
                                              return param.clipboard.writeText(text);
                                            }));
                            }), param);
              }), Relude_IO.fromOption((function (prim) {
                    
                  }), Curry._1(make, undefined)));
}

var Clipboard = {
  writeText: writeText
};

function fromDomRect(domRect) {
  return {
          bottom: domRect.bottom,
          height: domRect.height,
          left: domRect.left,
          right: domRect.right,
          top: domRect.top,
          width: domRect.width,
          x: domRect.x,
          y: domRect.y
        };
}

var Rect = {
  fromDomRect: fromDomRect
};

var partial_arg$6 = (function (param) {
    return Relude_Result.fold(Relude_IO.pure, removeMouseDownListener, param);
  });

function useClickOutside(param) {
  return ReactIO.useEffect2(partial_arg$6, undefined, (function (domRefs, wasClickedOutsideCallback) {
                return addMouseDownListener(function (target) {
                            var partial_arg = Curry._1(Relude_List.any, (function (param) {
                                    return Relude_Globals.$great$great((function (prim) {
                                                  return prim;
                                                }), (function (el) {
                                                  return el.contains(target);
                                                }), param);
                                  }));
                            return Relude_IO.flatMap((function (wasClickedInside) {
                                          if (wasClickedInside) {
                                            return Relude_IO.pure(undefined);
                                          } else {
                                            return Curry._1(wasClickedOutsideCallback, target);
                                          }
                                        }), Relude_IO.map((function (param) {
                                              return Relude_Globals.$great$great((function (param) {
                                                            return Relude_List.mapOption(Relude_Globals.id, param);
                                                          }), partial_arg, param);
                                            }), Curry._1(IOUtils.IOWithUnitError.all, domRefs)));
                          });
              }), param);
}

function useClickOutside$1(param, param$1) {
  return Relude_Function.curry2(useClickOutside, param, param$1);
}

var partial_arg$7 = (function (param) {
    return Relude_Result.fold(Relude_IO.pure, removeKeyDownEventListener, param);
  });

function useOnDocumentKeyDown(param) {
  return ReactIO.useEffect1(partial_arg$7, undefined, addKeyDownEventListener, param);
}

var partial_arg$8 = (function (param) {
    return Relude_Result.fold(Relude_IO.pure, removeWindowScrollListener, param);
  });

function useOnWindowScroll(param) {
  return ReactIO.useEffect1(partial_arg$8, undefined, addWindowScrollListener, param);
}

var partial_arg$9 = (function (param) {
    return Relude_Result.fold(Relude_IO.pure, removeWindowResizeListener, param);
  });

function useOnWindowResize(param) {
  return ReactIO.useLayoutEffect1(partial_arg$9, undefined, addWindowResizeListener, param);
}

function useDimensions(domRef) {
  var match = ReactIO.useState(function (param) {
        
      });
  var setSize = match[1];
  ReactIO.useLayoutEffect1((function (param) {
          return Relude_Result.fold(Relude_IO.pure, (function (param) {
                        return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                      return Relude_IO.map((function (prim) {
                                                    prim.disconnect();
                                                    
                                                  }), param);
                                    }), param);
                      }), param);
        }), undefined, (function (domRef) {
          var resizeObserver = new ResizeObserver((function (param) {
                  return Relude_Globals.$great$great((function (param) {
                                return Relude_Globals.$great$great((function (param) {
                                              return Relude_Globals.$great$great(Relude_Array.head, (function (param) {
                                                            return Relude_Option.map((function (param) {
                                                                          return Relude_Globals.$great$great((function (prim) {
                                                                                        return prim.contentRect;
                                                                                      }), fromDomRect, param);
                                                                        }), param);
                                                          }), param);
                                            }), setSize, param);
                              }), IOUtils.unsafeRunHandledAsync, param);
                }));
          return Relude_IO.map((function (param) {
                        return resizeObserver;
                      }), Relude_IO.map((function (param) {
                            return Relude_Option.fold(undefined, (function (param) {
                                          resizeObserver.observe(param);
                                          
                                        }), param);
                          }), domRef));
        }), domRef);
  return match[0];
}

function usePortal(children) {
  var modalElement = ReactIO.useState(function (param) {
          return document.createElement("div");
        })[0];
  ReactIO.useIOOnMount((function (param) {
          return Relude_Result.fold(Relude_IO.pure, (function (param) {
                        return Relude_Globals.$great$great(removeChildFromBody, (function (param) {
                                      return Relude_IO.map((function (prim) {
                                                    
                                                  }), param);
                                    }), param);
                      }), param);
        }), undefined, appendChildToBody(modalElement));
  return ReactDom.createPortal(children, modalElement);
}

function useScript(scriptContents) {
  var tmp;
  tmp = scriptContents.TAG === /* URL */0 ? "url" : "script";
  var scriptContents$1 = ReactIO.useMemo2((function (param, param$1) {
          return scriptContents;
        }), [
        tmp,
        scriptContents._0
      ]);
  return ReactIO.useEffect1((function (param) {
                return Relude_Result.fold(Relude_IO.pure, (function (param) {
                              return Relude_Globals.$great$great(removeChildFromHead, (function (param) {
                                            return Relude_IO.map((function (prim) {
                                                          
                                                        }), param);
                                          }), param);
                            }), param);
              }), undefined, (function (param) {
                return Relude_Globals.$great$great((function (value) {
                              if (value.TAG === /* URL */0) {
                                return Relude_IO.flatMap((function (param) {
                                              return setAttributeOnElement("async", "true", param);
                                            }), setAttributeOnElement("url", value._0, document.createElement("script")));
                              } else {
                                return setInnerHTMLOnElement(value._0, document.createElement("script"));
                              }
                            }), (function (param) {
                              return Relude_IO.flatMap(appendChildToHead, param);
                            }), param);
              }), scriptContents$1);
}

function watchUrl(onUrlChange) {
  return Relude_IO.suspend(function (param) {
              return ReasonReactRouter.watchUrl(function (param) {
                          return Relude_Globals.$great$great(onUrlChange, IOUtils.unsafeRunHandledAsync, param);
                        });
            });
}

function unwatchUrl(watcherId) {
  return Relude_IO.suspend(function (param) {
              return ReasonReactRouter.unwatchUrl(watcherId);
            });
}

var dangerouslyGetInitialUrl = Relude_IO.suspend(ReasonReactRouter.dangerouslyGetInitialUrl);

function pushUrl(previousUrl, nextUrl) {
  return Relude_IO.suspend(function (param) {
              if (Relude_String.eq(previousUrl, nextUrl)) {
                return ;
              } else {
                return ReasonReactRouter.push(nextUrl);
              }
            });
}

var Router = {
  watchUrl: watchUrl,
  unwatchUrl: unwatchUrl,
  dangerouslyGetInitialUrl: dangerouslyGetInitialUrl,
  pushUrl: pushUrl
};

exports.$$Window = $$Window;
exports.KeyMappings = KeyMappings;
exports.WebapiIO = WebapiIO;
exports.ScrollOptions = ScrollOptions;
exports.scrollRefIntoView = scrollRefIntoView$1;
exports.focusRef = focusRef$1;
exports.clickRef = clickRef$1;
exports.getRefScrollTop = getRefScrollTop$1;
exports.scrollRefIntoViewOnCondition = scrollRefIntoViewOnCondition;
exports.ieRegex = ieRegex;
exports.safariRegex = safariRegex;
exports.iosRegex = iosRegex;
exports.isIE = isIE;
exports.isSafari = isSafari;
exports.isSafariDesktop = isSafariDesktop;
exports.getValueFromEvent = getValueFromEvent;
exports.getCheckedFromEvent = getCheckedFromEvent;
exports.$$FileList = $$FileList;
exports.$$File = $$File;
exports.FileInput = FileInput;
exports.getFocusActionsFromEvent = getFocusActionsFromEvent;
exports.WindowSizing = WindowSizing;
exports.MediaMatch = MediaMatch;
exports.Clipboard = Clipboard;
exports.Rect = Rect;
exports.useClickOutside = useClickOutside$1;
exports.useOnDocumentKeyDown = useOnDocumentKeyDown;
exports.useOnWindowScroll = useOnWindowScroll;
exports.useOnWindowResize = useOnWindowResize;
exports.useDimensions = useDimensions;
exports.usePortal = usePortal;
exports.useScript = useScript;
exports.Router = Router;
/* scrollToTop Not a pure module */
